export default __webpack_public_path__ + "static/media/WorkSans-Regular.ccb81165.woff";